import * as React from "react"
import {Grid, Skeleton} from "@mui/material";
import {generateArrayByNumber} from "@ui-seeker/utils";


export default function MatchersSkeleton() {
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <Skeleton variant="rectangular" height={50} />
        </Grid>

        <Grid item xs={7} xl={6}>
            <Skeleton variant="rectangular" height={780} />
        </Grid>

        <Grid item xs={5} xl={6}>
            <Grid container spacing={4}>
                { generateArrayByNumber(4).map(idx => <OptionSkeleton key={idx} />) }
            </Grid>
        </Grid>
    </Grid>
}

const OptionSkeleton = () => <>
    <Grid item xs={3}>
        <Skeleton variant="rectangular" height={170} />
    </Grid>

    <Grid item xs={9} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Skeleton height={50} />
        <Skeleton height={50} />
        <Skeleton height={50} />
    </Grid>
</>